import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faCheck } from '@fortawesome/pro-regular-svg-icons'

import './card.css'

const EmailField = React.memo(function EmailField ({
  value, setValue, addButton, isRemove, confirmed, onConfirm
}) {
  const handleChange = useCallback((event) => {
    if (setValue) setValue(event.target.value)
  }, [setValue])

  const isEditing = !confirmed
  const canEdit = Boolean(setValue)

  return (
    <div className={`email-field${isEditing ? ' email-field--editable' : ''}`}>
      <input
        type='email'
        className='email-input'
        readOnly={!canEdit}
        placeholder={canEdit ? 'Escreva o email aqui...' : ''}
        aria-label='Email'
        value={value.value}
        onChange={handleChange}
      />
      {!isEditing && isRemove && addButton && (
        <button type='button' className='email-remove-btn email-remove-btn--gray' onClick={addButton}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
      {isEditing && (
        <>
          {isRemove && addButton && (
            <button type='button' className='email-remove-btn' onClick={addButton}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
          <button
            type='button'
            className={`email-confirm-btn${value.valid ? '' : ' email-confirm-btn--invalid'}`}
            disabled={!value.valid}
            onClick={onConfirm}
          >
            <FontAwesomeIcon icon={faCheck} />
          </button>
        </>
      )}
    </div>
  )
})

EmailField.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired
  }).isRequired,
  setValue: PropTypes.func,
  confirmed: PropTypes.bool,
  addButton: PropTypes.func,
  isRemove: PropTypes.bool,
  onConfirm: PropTypes.func
}

export default EmailField
